// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { MoreVertical } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconMoreVertical(props: any) {
    return <IconBase icon={MoreVertical} {...props} />
  }

  export default IconMoreVertical
  